import React from 'react'
import * as S from './DownloadDocument.Style'

import { ReactComponent as Download } from "../../../../assets/images/habitacional/icon-download.svg";

const DownloadDocument = ({ documents }) => {
    return (
        <S.List>
            {documents.map(( d )=> { return (
                <S.Item 
                    key={d.link}
                    href={d.link}
                    target="_blank"
                >
                    <Download />
                    {d.text}
                </S.Item>
            )})}
        </S.List>
    )
}

export default DownloadDocument